module.exports = __webpack_public_path__ + "static/erkelenz-7d7f86e4573df2c72f4fc7b6e4ce900c.jpg";